
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/timber",
      function () {
        return require("private-next-pages/timber/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/timber"])
      });
    }
  